module.exports = __webpack_public_path__ + "static/media/draw-circle.54c8a1be.svg";